<script lang="ts">
  import {  FormGroup,Input} from "sveltestrap";
  import { DefaultSwitch, DefaultSwitchMessage, DisableSwitch, DisableSwitchMessage, SwitchColor, SwitchColorMessage, SwitchOutline, SwitchOutlineMessage } from "../../../../utils/Constant/Constant";
</script>
<tr>
    <td class="pills-component">{DefaultSwitch}</td>
    <td class="w-50">
        <FormGroup>
            <Input id="c3" checked type="switch" />
        </FormGroup>
    </td>
    <td><span>{@html DefaultSwitchMessage}</span></td>
  </tr>
  <tr>
    <td>{DisableSwitch}</td>
    <td class="w-50">
        <FormGroup>
            <Input id="c4" disabled type="switch" />
        </FormGroup>
    </td>
    <td><span>{@html DisableSwitchMessage}</span></td>
  </tr>
  <tr>
    <td>{SwitchColor}</td>
    <td class="w-50">
        <FormGroup>
            <Input id="c5" checked type="switch" />
        </FormGroup>
    </td>
    <td><span>{@html SwitchColorMessage}</span></td>
  </tr>
  <tr>
    <td>{SwitchOutline}</td>
    <td class="w-50">
        <FormGroup>
            <Input id="c6" checked type="switch" />
        </FormGroup>
    </td>
    <td><span>{@html SwitchOutlineMessage}</span></td>
  </tr>